import { render, staticRenderFns } from "./diffs_file_tree.vue.js?vue&type=template&id=25a61620&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diffs_file_tree.vue?vue&type=template&id=25a61620&vue3"
import script from "./diffs_file_tree.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diffs_file_tree.vue?vue&type=script&lang=js&vue3"
export * from "./diffs_file_tree.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./diffs_file_tree.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports